import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import WpBaseComponent from '../../wp-base-component';

@Component({
    template: require("./wp-loading-overlay.html")
})
export default class WpLoadingOverlay extends mixins<WpBaseComponent>(WpBaseComponent, Vue) {
};
